import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import DynamicContent from "../nav/DynamicContent";
import {ContentContext} from "../common/ContentContext";

const WidgetPlayer = props => {
    const {mediaId, conceptId} = props;
    const {content, dialogMediaObject} = useContext(ContentContext);
    const mediaConceptId = conceptId ? conceptId : content.currentConcept.conceptId;

    return (
        <>
            {mediaId &&
                <div className="ch-widget-player js-pw-btn-blk">
                    <DynamicContent url="/lessonSection/displayWidgetEmbedded.action"
                                    params={{mediaId: mediaId, conceptId: mediaConceptId, dialogWidget: dialogMediaObject != null}}
                                    updateHash={false}  />
                </div>
            }
            {!mediaId &&
                <div className={'ch-warning-text'}>No widget to load</div>
            }
        </>
    );
};

export default WidgetPlayer;
